module.exports = __webpack_public_path__ + "img/first_bg_dark.a5c2a093.png";